var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_vm._v(" © "+_vm._s(_vm.startYear == _vm.year ? _vm.startYear : (_vm.startYear + " - " + _vm.year))+" PT Lingkar Sembilan Titian Media ")])}
var staticRenderFns = []

export { render, staticRenderFns }